// src/services/avatarService.ts
import { auth } from './firebase';
import { config } from '../config';

/**
 * バックエンド経由でアバター画像をアップロードする関数
 * @param blob 画像Blob
 * @returns アップロードされた画像のURL
 */
export const uploadAvatar = async (blob: Blob): Promise<string> => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error('認証されていません。ログインしてください。');
  }

  try {
    // 認証トークンを取得
    const token = await user.getIdToken(true);

    // BlobをFileに変換
    const file = new File([blob], 'avatar.jpg', { type: 'image/jpeg' });

    // FormDataを作成
    const formData = new FormData();
    formData.append('file', file);

    // APIにPOSTリクエスト
    const response = await fetch(`${config.apiBaseUrl}/api/users/avatar`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${token}`
      },
      body: formData
    });

    // レスポンスの詳細情報を取得
    const responseText = await response.text();

    // JSONとして解析を試みる
    let data;
    try {
      data = JSON.parse(responseText);
    } catch (e) {
      console.error('JSONパースエラー:', e);
      throw new Error('サーバーからの応答を解析できませんでした');
    }

    if (!response.ok) {
      console.error('APIエラーレスポンス:', data);
      throw new Error(data.detail || 'アップロードに失敗しました');
    }

    if (!data.avatarUrl) {
      throw new Error('画像URLが返されませんでした');
    }

    return data.avatarUrl;
  } catch (error) {
    console.error('アバターアップロードエラー:', error);
    throw error;
  }
};
